import { gql } from '@apollo/client';

export const UPSERT_WORKSPACE_TEMPLATE = gql`
  mutation upsertWorkspaceTemplate($input: UpsertWorkspaceTemplateInput!) {
    workspaceForm: upsertWorkspaceTemplate(input: $input) {
      id
      template {
        id
        jsonData
      }
    }
  }
`;
